import React, {useContext, useEffect} from 'react';
import {Route, Switch, useRouteMatch, withRouter, Redirect} from 'react-router-dom';
import {ReservationWrapper} from "./Reservation.style";
import {Loader} from '../../components/common';
import { ReservationRoutes } from "./routes";
import {ReservationInputs} from "./components/ReservationInputs";
import {useDispatch, useSelector} from "react-redux";
import {selectMarina, selectReady} from "../../store/slices/app/selectors";
import {appActions} from "../../store/slices/app/appSlice";
import {authActions} from "../../store/slices/auth/authSlice";
import ReservationData from "./components/ReservationData/ReservationData";
import {AuthContext} from "../../context/AuthProvider";
import {PopeyeContext} from "../../context/PopeyeProvider";
import usePromotions from "./usePromotions";
import {reservationActions} from "../../store/slices/reservation/reservationSlice";

const Reservation = () => {
    const dispatch = useDispatch();
    const ready = useSelector(selectReady);
    const match = useRouteMatch();

    useEffect(() => {
        dispatch(appActions.initialize());
        dispatch(authActions.init());
    }, [dispatch]);


    if(!ready) return null;

    return (<ReservationWrapper>
        <Switch>
            <Route exact path={`${match.path}/${ReservationRoutes.Home}`} component={ReservationInputs} />
            <Route path={`${match.path}/${ReservationRoutes.Finished}`} component={ReservationData} />
            <Route path={`${match.path}/${ReservationRoutes.Reservation}`} component={ReservationData} />
            <Redirect to={`${match.path}/${ReservationRoutes.Home}`} />
        </Switch>
        <Loader />
    </ReservationWrapper>);
}

export default withRouter(Reservation);
